<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <component-header
                    title="Delivery Setup Details"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="$router.push('/setup/deliverysetup')"
                />
            </b-col>
            <b-col md="12">
                <b-card class="Account-card" height="157">
                    <b-row class="m-2">
                        <b-col md="3">
                            <b-row>
                                <h4>State :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.state }}
                                </h4>
                            </b-row>
                        </b-col>
                        <b-col md="3">
                            <b-row>
                                <h4>City :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.city }}
                                </h4>
                            </b-row>
                        </b-col>
                        <b-col md="3">
                            <b-row>
                                <h4>Area :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.areacode }}
                                </h4>
                            </b-row>
                        </b-col>
                        <b-col md="3">
                            <b-row>
                                <h4>Transport Mode :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.transportMode }}
                                </h4>
                            </b-row>
                        </b-col>
                        <!-- <b-col md="3">
              <b-row>
                <h4>Start Date :</h4>
                <h4 class="ml-1  text-muted">{{ inputObject.startDate }}</h4>
              </b-row>
            </b-col> -->
                    </b-row>
                    <b-row class="m-2 p-0">
                        <b-col md="3">
                            <b-row>
                                <h4>Start Date :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.startDate }}
                                </h4>
                            </b-row>
                        </b-col>
                        <b-col md="3">
                            <b-row>
                                <h4>End Date :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.endDate }}
                                </h4>
                            </b-row>
                        </b-col>
                        <b-col md="3">
                            <b-row class="align-items-center flex-nowrap">
                                <h4 class="mb-0">Category:</h4>
                                <h4 class="ml-1 text-muted mb-0">
                                    {{ inputObject.category }}
                                </h4>
                            </b-row>
                        </b-col>
                        <b-col md="3">
                            <b-row>
                                <h4>Rank :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.rank }}
                                </h4>
                            </b-row>
                        </b-col>
                        <b-col md="3">
                            <b-row>
                                <h4>Default charge :</h4>
                                <h4 class="ml-1 text-muted">
                                    {{ inputObject.dwf }}
                                </h4>
                            </b-row>
                        </b-col>

                        <b-col md="3">
                            <b-row class="align-items-center flex-nowrap">
                                <h4 class="mb-0">Delivery Owner:</h4>
                                <h4 class="ml-1 text-muted mb-0">
                                    {{ inputObject.deliveryOwner }}
                                </h4>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <div>
            <b-row>
                <b-col md="8">
                    <h4>Distance Tier</h4>
                </b-col>
            </b-row>
            <div v-for="(tier, idx) in inputObject.distanceTier" :key="idx">
                <v-card class="mt-1 mb-3">
                    <b-row
                        style="background-color: var(--secondary)"
                        class="m-0"
                    >
                        <b-col md="6">
                            <h4 class="text-white">
                                Distance Tier Name : {{ tier.tier }}
                            </h4>
                        </b-col>
                        <b-col md="2"></b-col>
                        <b-col md="2">
                            <h4 class="text-white">
                                Start Range(KM) : {{ tier.from }}
                            </h4>
                        </b-col>
                        <b-col md="2">
                            <h4 class="text-white">
                                End Range(KM) : {{ tier.to }}
                            </h4>
                        </b-col>
                    </b-row>
                    <b-row
                        v-for="(weight, wIdx) in tier.weight"
                        :key="wIdx"
                        class="p-0 m-2"
                    >
                        <b-col>
                            <b-row>
                                <label class="mr-1"
                                    ><b>Start Range (KG) : </b></label
                                >
                                {{ weight.from }}
                            </b-row>
                        </b-col>
                        <b-col>
                            <b-row>
                                <label class="mr-1"
                                    ><b>End Range (KG) : </b></label
                                >
                                {{ weight.to }}
                            </b-row>
                        </b-col>

                        <b-col>
                            <b-row>
                                <label class="mr-1"><b>Time : </b></label>
                                {{ weight.etd ? weight.etd.time : "" }}
                                {{ weight.etd ? weight.etd.uom : "" }}
                            </b-row>
                        </b-col>
                        <b-col>
                            <b-row>
                                <label class="mr-1"
                                    ><b>Customer Cost : </b></label
                                >
                                {{ weight.customerFee }}
                            </b-row>
                        </b-col>

                        <b-col>
                            <b-row>
                                <label class="mr-1"
                                    ><b>Delivery Cost : </b></label
                                >
                                {{ weight.deliveryAgentFee }}
                            </b-row>
                        </b-col>
                    </b-row>
                </v-card>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import cInput from "@/components/Common/CustomInput";
import ebButton from "@/components/FormElements/Button";
import currentUser from "@/mixins/currentUser";
import ComponentHeader from "@/components/componentNewHeader";
export default {
    mixins: [currentUser],
    components: {
        cInput,
        ebButton,
        ComponentHeader,
    },
    data() {
        return {
            inputObject: {
                city: "",
                state: "",
                category: "",
                transportMode: "",
                startDate: "",
                endDate: "",
                rank: "",
                areacode: "",
                dwf: "",
                deliveryOwner: "",
                distanceTier: [
                    {
                        tier: "",
                        from: "",
                        to: "",
                        isRemovable: false,
                        weight: [
                            {
                                from: "",
                                to: "",
                                customerFee: "",
                                deliveryAgentFee: "",
                                isRemovable: false,
                            },
                        ],
                    },
                ],
            },
            details: {},
        };
    },
    // props: {
    //   details: {
    //     type: Object,
    //     required: true,
    //   },
    // },
    computed: {},
    async mounted() {
        if (this.$route.params.data) {
            this.details = { ...this.$route.params.data };
        } else if (this.$route.params.id) {
            try {
                const data = await this.$store.dispatch(
                    "delivery/fetchDeliverySetupById",
                    this.$route.params.id,
                );
                const raw = Array.isArray(data) ? data[0] : data;
                this.details = raw
                    ? {
                          ...raw,
                          StartDate: raw.startDate
                              ? moment(raw.startDate).format("DD/MM/yyyy")
                              : "",
                          EndDate: raw.endDate
                              ? moment(raw.endDate).format("DD/MM/yyyy")
                              : "",
                      }
                    : {};
            } catch (err) {
                this.$toasted?.error?.("Failed to load delivery setup");
                this.$router.push("/setup/deliverysetup");
                return;
            }
        } else {
            this.$router.push("/setup/deliverysetup");
            return;
        }
        this.initializeInputObject();
        await this.ensureCatalogTree();
        this.setCategoryName();
    },
    methods: {
        initializeInputObject() {
            this.inputObject.city =
                this.details.city === "*" ? "All cities" : this.details.city;
            this.inputObject.state =
                this.details.state === "*" ? "All states" : this.details.state;
            this.inputObject.transportMode = this.details.transportMode;
            this.inputObject.startDate = this.details.StartDate;
            this.inputObject.endDate = this.details.EndDate;
            this.inputObject.rank = this.details.rank;
            this.inputObject.dwf = this.details.dwf;
            this.inputObject.areacode = this.details.areaCode;
            this.inputObject.deliveryOwner =
                this.details.deliveryOwner?.name || "";
            this.inputObject.distanceTier = this.details.distance || [];
        },
        async ensureCatalogTree() {
            const isTenant = this.$userRole === "Tenant";
            const getterName = isTenant
                ? "catalog/GetTenantCatalogTree"
                : "catalog/GetPartnerCatalogTree";
            const actionName = isTenant
                ? "catalog/fetchTenantCatalogTree"
                : "catalog/fetchPartnerCatalogTree";

            const catalogTree = this.$store.getters[getterName];
            if (!catalogTree || catalogTree.length === 0) {
                await this.$store.dispatch(actionName);
            }
        },
        setCategoryName() {
            const isTenant = this.$userRole === "Tenant";
            const getterName = isTenant
                ? "catalog/GetTenantCatalogTree"
                : "catalog/GetPartnerCatalogTree";

            const catalogTree = this.$store.getters[getterName];
            if (!catalogTree || catalogTree.length === 0) {
                this.inputObject.category = "All categories";
                return;
            }

            const filteredList = catalogTree.filter(
                (obj) => obj._id === this.details.category_id,
            );
            this.inputObject.category =
                filteredList.length > 0 && filteredList[0].name
                    ? filteredList[0].name
                    : "All categories";
        },
    },
};
</script>

<style scoped>
p {
    font-size: 13px;
}
.Account-card {
    background-color: #ffffff;
    padding-top: 0px;
    border-radius: 15px;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
}
th,
td {
    padding: 8px;
    color: #000000;
    font-weight: bold;
}
th {
    width: 46%;
    color: #8f8f8f;
}
</style>
